import { Box, Button, CircularProgress, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BiLeftArrowCircle,
  BiRadioCircle,
  BiRadioCircleMarked,
  BiCheckbox,
  BiCheckboxChecked,
} from "react-icons/bi";
import ReplaceImage from "../images/icons/window-replace.png";
import RepairImage from "../images/icons/window-repair.png";
import "./../step_form.scss";
import ToolTipComponent from "./ToolTipComponent";
import axios from "axios";
const StepForm = ({ActiveStep, setActiveStep}) => {

  const [InputVal, setInputVal] = React.useState({});
  const handleNext = (val = 1) => {
    if (val) {
      setActiveStep((prevActiveStep) => prevActiveStep + val);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };
  const handleBack = (val = 1) => {
    setActiveStep((prevActiveStep) => prevActiveStep - val);
  };

  const [CardButton, setCardButton] = useState({
    Zip_Code: true,
    replace_repair: true,
    need_replaced: true,
    your_info: true,
    Street_Address: true,
    contactDetail: true,
    financing: true,
  })
 
  

const submitForm = async () => {

  handleNext();
  
  let pera = InputVal; 
  // console.log(InputVal);
  await axios.post('https://vasudeep.com:8084/https://mrkaiweb.com/mail/index.php', pera).then(res=>{
    let resData = res.data;
    console.log(resData.status);
    if(resData.status === true){
      window.location.href  = "https://windowreplacementquote.com/thank-you";
      console.log('res.data')
    }else{
      console.log('false')
    }
  }).catch(err=>{
    console.log(err)
  })
}


  const changeInput = (event) => {

    let cBActive = true;
    let cardButtonKey;
    if(event.target.name === "Zip_Code"){
      if(event.target.value.length===5){
        cBActive = false;
        cardButtonKey = "Zip_Code";
      }
    }else
    if(event.target.name == 'First_Name' || event.target.name == "Last_Name"){
      if(InputVal.First_Name != "" && InputVal.Last_Name != ""){
        // console.log('InputVal?.First_Name', InputVal?.First_Name, InputVal?.Last_Name)
        cBActive = false;
        cardButtonKey = "your_info";
      }
    }else
    if(event.target.name == 'Street_Address' && InputVal?.Street_Address != ""){
      cBActive = false;
      cardButtonKey = "Street_Address";
    }else
    if(event.target.name == 'Email_Address' || event.target.name != "Cell_Number"){
      if(InputVal?.Email_Address != "" && InputVal?.Cell_Number != ""){
        cBActive = false;
        cardButtonKey = "contactDetail";
      }
    } 

    console.log('event.target.name >>',event.target.name);
    console.log('InputVal >>',InputVal);
    console.log('cardButtonKey >>',cardButtonKey);
    
    let val1 = {...InputVal, [event.target.name]:event.target.value}
    setInputVal(val1);
    let cardButton = {...CardButton, [cardButtonKey]: cBActive}
    setCardButton(cardButton);
  };

  const zipCode = () => {
    return (
      <>
        <div className="step_item ">
          <Typography className="ms-title">
            Please give us a few details so we can connect you with the best
            pros.
          </Typography>
          <div className="input_container">
            <label style={{ fontWeight: "300" }}>
              Enter your Zip Code to start
            </label>
            <TextField
              className="inputField"
              onChange={(e) => changeInput(e)}
              id="outlined-basic"
              variant="outlined"
              placeholder="Zip Code"
              value={InputVal?.Zip_Code}
              name="Zip_Code"
              textAlign="center" 
              inputProps={{ pattern: "[0-9]{5}", maxLength:5, max:"99999" }}
            />
          </div>

          <div className="button_container">
            {/* <div className="back_btn">
                    <BiLeftArrowCircle />
                </div> */}
            <div className="next_btn">
              <Button
                className="actionButton"
                variant="contained"
                onClick={() => handleNext()}
                disabled={CardButton.Zip_Code}
              >
                GET STARTED
              </Button>
            </div>
          </div>
          <div className="f_logos">
            <img src="https://windowreplacementquote.com/images/logo-google.png" alt="" />
            <img src="https://windowreplacementquote.com/images/logo-bbb.png" alt="" />
            <img src="https://windowreplacementquote.com/images/angi.jpeg" alt="" />
          </div>
        </div>
      </>
    );
  };


  const [ExistingWindowType, setExistingWindowType] = useState(0);
  const selectExistingWindow = (type) => {
    if (type == "Repair") {
      setExistingWindowType(2);
    } else {
      setExistingWindowType(1);
    }
    let cBActive = false;
    let cardButton = {...CardButton, replace_repair: cBActive}
    setCardButton(cardButton);
    
    let val1 = {...InputVal, replace_repair:type}
    setInputVal(val1);
  };
  const replace_repair = () => {
    return (
      <>
        <div className="step_item ">
          <Typography className="ms-title">
            Do you want to replace or repair existing windows?
          </Typography>
          <div className="icon_box_container">
            <div
              className={`iconDiv ${
                ExistingWindowType === 1 ? "box_active" : ""
              }`}
              onClick={() => selectExistingWindow("Replace")}
            >
              <img src={ReplaceImage} />
              <div>Replace</div>
            </div>
            <div
              className={`iconDiv ${
                ExistingWindowType === 2 ? "box_active" : ""
              }`}
              onClick={() => selectExistingWindow("Repair")}
            >
              <img src={RepairImage} />
              <div>Repair</div>
            </div>
          </div>
          <div className="button_container">
            <div
              className="back_btn"
              onClick={() => handleBack(ExistingWindowType===0 ? 1 : ExistingWindowType)}
            >
              <BiLeftArrowCircle />
            </div>
            <div className="next_btn">
              <Button
                className="actionButton"
                variant="contained"
                onClick={() => handleNext(ExistingWindowType)}
                disabled={CardButton.replace_repair}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      </>
    );
  };

  const [SelectNeedReplaced, setSelectNeedReplaced] = useState(0);


  const need_replaced = () => {
    return(
      <>
        <div className="step_item ">
            <Typography className="ms-title">
              How many windows do you need replaced?
            </Typography>
            <div className="input_container">
            {
              needReplacedArr.map((item)=>{
                return (
                  <label class={`label-item ${SelectNeedReplaced == item?.value ? "label-item-active" : "" }`} onClick={()=>{
                    setSelectNeedReplaced(item?.value);
                    let cBActive = false;
                    let cardButton = {...CardButton, need_replaced: cBActive}
                    setCardButton(cardButton);
                    let val1 = {...InputVal, need_replaced:item?.value}
                    setInputVal(val1);
                  }} ><span>{item.label}</span></label>
                )
              })
            }
            </div>

            <div className="button_container">
              <div className="back_btn" onClick={() => handleBack()}>
                <BiLeftArrowCircle />
              </div>
              <div className="next_btn">
                <Button
                  className="actionButton"
                  variant="contained"
                  onClick={() => handleNext()}
                  disabled={CardButton.need_replaced}
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
      </>
    )
  };

  const your_info = () => {
    return (
      <>
        <div className="step_item ">
          <Typography className="ms-title">
            Window Pros found! Please enter your full name.
          </Typography>
          <div className="input_container">
            <label style={{ fontWeight: "300" }}>
              Enter your information and get your results - fast!
            </label>
            <TextField
              className="inputField"
              onChange={(e) => changeInput(e)}
              id="outlined-basic"
              variant="outlined"
              placeholder="First Name"
              name="First_Name"
              value={InputVal?.First_Name}
              textAlign="center"
            />
            <TextField
              className="inputField"
              onChange={(e) => changeInput(e)}
              id="outlined-basic"
              variant="outlined"
              placeholder="Last Name"
              name="Last_Name"
              value={InputVal?.Last_Name}
              textAlign="center"
              sx={{}}
            />
          </div>

          <div className="button_container">
            <div className="back_btn" onClick={() => handleBack(ExistingWindowType)}>
              <BiLeftArrowCircle />
            </div>
            <div className="next_btn">
              <Button
                className="actionButton"
                variant="contained"
                onClick={() => handleNext()}
                disabled={CardButton.your_info}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      </>
    );
  };

  const address = () => {
    return (
      <>
        <div className="step_item ">
          <Typography className="ms-title">
            What is your street address?
          </Typography>
          <div className="input_container">
            <TextField
              className="inputField"
              onChange={(e) => changeInput(e)}
              id="outlined-basic"
              variant="outlined"
              placeholder="Street Address"
              name="Street_Address"
              value={InputVal?.Street_Address}
              textAlign="center"
            />
          </div>

          <div className="button_container">
            <div className="back_btn" onClick={() => handleBack()}>
              <BiLeftArrowCircle />
            </div>
            <div className="next_btn">
              <Button
                className="actionButton"
                variant="contained"
                onClick={() => handleNext()}
                disabled={CardButton.Street_Address}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      </>
    );
  };

  const contactDetail = () => {
    return (
      <>
        <div className="step_item ">
          <Typography className="ms-title">
            We have matching window installers in your area!
          </Typography>
          <div className="input_container">
            <label style={{ fontWeight: "300" }}>
              Where should we send your matches?
            </label>
            <TextField
              className="inputField"
              onChange={(e) => changeInput(e)}
              id="outlined-basic"
              variant="outlined"
              placeholder="Email Address"
              name="Email_Address"
              value={InputVal?.Email_Address}
              textAlign="center"
            />
            <TextField
              className="inputField"
              onChange={(e) => changeInput(e)}
              id="outlined-basic"
              variant="outlined"
              placeholder="Cell Number"
              name="Cell_Number"
              value={InputVal?.Cell_Number}
              textAlign="center"
              sx={{}}
            />
          </div>

          <div className="button_container">
            <div className="back_btn" onClick={() => handleBack()}>
              <BiLeftArrowCircle />
            </div>
            <div className="next_btn">
              <Button
                className="actionButton"
                variant="contained"
                onClick={() => handleNext()}
                disabled={CheckBoxX == true && CardButton.contactDetail == false ? false : true}
              >
                Next
              </Button>
            </div>
          </div>
          <div style={{ textAlign:'left', display:'flex', alignItems:'flex-start' }}>
          <div>
          <div className="radio_item" onClick={()=>{
            // console.log(CardButton.contactDetail)
            // console.log(CheckBoxX)
              setCheckBoxX(!CheckBoxX);
            }}>
              <div>
              {
                CheckBoxX ?
                  <BiCheckboxChecked />
                :
                  <BiCheckbox />
              }
              </div>
            </div>
          </div>
          <div style={{ fontSize:'12px' }}>
          I agree to the Terms of Service and <a style={{ color:'#333aba' }} href="https://brandaid.netengine.co/privacy-page" target="_blank">Privacy Policy</a> and authorize up to two home improvement companies, their contractors and partners to contact me with offers about home improvement products or service by mobile or landline telephone calls, artificial voice, and pre-recorded/SMS messages, using an automated telephone technology, to the number I provided above, even if my number is a mobile number or is currently listed on any state, federal or corporate Do Not Call list. I understand that my consent here is not a condition of purchase of any goods or services. Message and data rates may apply. Do Not Sell/California Residents.
          </div>
          </div>
        </div>
      </>
    );
  };

  const [FinancingVal, setFinancingVal] = useState(null);
  const [CheckBoxX, setCheckBoxX] = useState(true);



  const selectFinancingVal = (val) => {
    setFinancingVal(val);
    let cBActive = false;
    let cardButton = {...CardButton, financing: cBActive}
    setCardButton(cardButton);
    let val1 = {...InputVal, financing:val}
    setInputVal(val1);
  }
  const financing = () => {
    return (
      <>
        <div className="step_item ">
          <Typography className="ms-title">
            Would you be interested in financing?
          </Typography>
          <div className="input_container">
            <div className="radio_item" onClick={()=>{
              selectFinancingVal('Yes');
            }}>
              <div>
                {
                  FinancingVal == 'Yes' ?
                    <BiRadioCircleMarked />
                  :
                    <BiRadioCircle />
                }
              </div>
              <div>Yes</div>
            </div>
            <div className="radio_item" onClick={()=>{
              selectFinancingVal('No');
            }}>
              <div>
              {
                  FinancingVal == 'No' ?
                    <BiRadioCircleMarked />
                  :
                    <BiRadioCircle />
                }
              </div>
              <div>No</div>
            </div>
          </div>

          <div className="button_container">
            <div className="back_btn" onClick={() => handleBack()}>
              <BiLeftArrowCircle />
            </div>
            <div className="next_btn">
              <Button
                className="actionButton"
                variant="contained"
                onClick={() => submitForm()}
                disabled={CardButton?.financing}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      </>
    );
  };

  const submitData = () => {
    return (
      <>
        <div className="step_item ">
          <Typography className="ms-title">
            Please wait...
          </Typography>
          <div className="input_container">
          <Box sx={{ display: 'flex', justifyContent:'center' }}>
            <CircularProgress />
          </Box>
          </div>

        </div>
      </>
    );
  };

  const needReplacedArr = [
    { 
      value: "1-2",
      label: "1-2"
    },
    { 
      value: "3-5",
      label: "3-5"
    },
    { 
      value: "6-9",
      label: "6-9"
    },
    { 
      value: "10+",
      label: "10+"
    }
  ];

  return (
    <>
      <Box textAlign={"center"}>
        <div className="page-title">
          {ActiveStep === 1 && (
            <Typography className="heading1">
              Let's find you local Windows Pros
            </Typography>
          )}
        </div>
        <div className="stepContainer">
          
            { ActiveStep === 1 && zipCode() }
            { ActiveStep === 2 && replace_repair() }
            { ActiveStep === 3 && need_replaced() }
            { ActiveStep === 4 && your_info() }
            { ActiveStep === 5 && address() }
            { ActiveStep === 6 && contactDetail() }
            { ActiveStep === 7 && financing() }
            { ActiveStep === 8 && submitData() }

          {/* 
            {zipCode()}
            {replace_repair()}
            {your_info()}
            {address()}
            {contactDetail()}
            {financing()}
             */}
        </div>
      </Box>
    </>
  );
};

export default StepForm;
